<template>
    <div v-editable="blok">
        <FormInput
            pattern="^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$"
            type="email"
            name="email"
            :required="blok.required"
            autocomplete="email"
            placeholder="e.g. jack@myemail.com"
            v-model="value"
        ></FormInput>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import FormInput from "@/components/form/FormInput";

export default {
    name: 'profile-email',
    components: {
        FormInput
    },
    props: {
        blok: Object
    },
    computed: {
        ...mapState({
            user: state => state.profile.user
        }),
        value: {
            get: function() {
                return this.user.email;
            },
            set: function(value) {
                this.updateEmailAddress(value);
            }
        }
    },
    methods: {
        ...mapActions("profile", ["updateEmailAddress"])
    }
}
</script>